import { useAction, useAtom } from '@reatom/npm-react'
import React, { useMemo, useState } from 'react'
import styled from 'styled-components'

import { Button, CloseIcon } from '@blade/ui-kit'
import { WalletAddress } from '@root/entities/wallet'
import { walletsAtom } from '@root/entities/wallet/atoms'
import { WalletSelectorDrawer } from '@root/widgets/wallet'

import { TransferCardAddressInput } from './transfer-card-address-input'
import { TransferWalletInfo } from './transfer-wallet-info'

import type { TransferFlowReatom } from '../../../atoms/transfer-flow'
import type { WalletModel } from '@root/entities/wallet/atoms'

type Props = {
  model: TransferFlowReatom
  selectedWallet?: WalletModel
}

export const TransferCardAddress: React.FC<Props> = ({
  model,
  selectedWallet,
}) => {
  const [selectorOpen, setSelectorOpen] = useState(false)
  const [walletsAvailable] = useAtom(walletsAtom)

  const [address] = useAtom(model.destination.addressAtom)
  const [currency] = useAtom(model.currency.currencyAtom)
  const [destinationWallet] = useAtom(model.destination.destinationWalletAtom)
  const [destinationBalance] = useAtom(
    model.destination.destinationWalletAssetBalance,
  )

  const changeAddress = useAction(model.destination.setAddressAction)

  // filter out selected wallet
  const walletsFiltered = useMemo(
    () => walletsAvailable.filter((it) => it.id !== selectedWallet?.id),
    [walletsAvailable, selectedWallet],
  )

  const renderRecipient = () => {
    if (destinationWallet) {
      return (
        <WalletContainer>
          <TransferWalletInfo
            balance={destinationBalance}
            currency={currency}
            wallet={destinationWallet}
          />

          <Button
            size="xs"
            variant="soft"
            iconLeft={<CloseIcon />}
            onClick={() => {
              changeAddress(WalletAddress(''))
            }}
          />
        </WalletContainer>
      )
    }

    return (
      <TransferCardAddressInput
        value={address}
        onChange={changeAddress}
        onWalletClick={() => {
          setSelectorOpen(true)
        }}
      />
    )
  }

  return (
    <Root>
      {renderRecipient()}
      <WalletSelectorDrawer
        wallets={walletsFiltered}
        open={selectorOpen}
        onOpenChange={setSelectorOpen}
        onWalletClick={(wallet) => {
          changeAddress(wallet.address)
          setSelectorOpen(false)
        }}
      />
    </Root>
  )
}

const Root = styled.div``

const WalletContainer = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr auto;
`
